import { useworkspaceAuthMeV2Query } from '@/types/generated/graphql';
import { cacheOnly } from '@shared/constants';

export const useDesignVersion = () => {
  const { data: wksData, loading } = useworkspaceAuthMeV2Query(cacheOnly);
  const isPermanentlyMigrated = !loading && !!wksData?.workspaceAuthMeV2?.data?.v2MigratedAt;
  return {
    loading,
    isPermanentlyMigrated,
  };
};
